import { heroPills, heroStats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden border-b border-background-200/70">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-200/45 blur-3xl"></div>
      <div className="pointer-events-none absolute -right-16 top-40 h-80 w-80 rounded-full bg-accent-200/45 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-12 lg:gap-8 lg:py-20">
        <div className="animate-fade-up lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 font-label text-xs font-medium tracking-wide text-primary-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-play-circle-line text-base"></i>
            </span>
            一站式视频合集 · 打开就能刷
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-[2.75rem] md:leading-[1.2]">
            热门短视频、福利视频、最新资源，
            <span className="text-primary-600">一站式免费畅看</span>
          </h1>

          <p className="mt-5 max-w-xl font-body text-base leading-8 text-foreground-600 md:text-[17px]">
            分类清晰、更新及时，通勤路上或睡前放松都能刷到对味的内容。高清流畅不卡顿，
            打开糖豆视频，随时随地畅享属于你的下一条。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <div className="flex flex-1 items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2.5 md:py-3">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-lg"></i>
              </span>
              <input
                type="text"
                placeholder="搜一搜短视频、福利视频、最新资源…"
                className="w-full bg-transparent font-label text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="button"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-fill text-base"></i>
              立即观看
            </button>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-2">
            <span className="mr-1 font-label text-xs text-foreground-400">热门入口</span>
            {heroPills.map((pill) => (
              <button
                key={pill}
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-full border border-background-200 bg-background-100/70 px-3 py-1.5 font-label text-xs text-foreground-600 transition-colors hover:border-accent-300 hover:bg-accent-50 hover:text-accent-800"
              >
                {pill}
              </button>
            ))}
          </div>
        </div>

        <div className="relative lg:col-span-5">
          <div className="relative mx-auto w-full max-w-[420px] lg:max-w-none">
            <div className="h-[440px] w-full overflow-hidden rounded-[28px] border border-background-200 bg-background-100 md:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Bold%20stylized%20editorial%20poster%20illustration%20of%20a%20vibrant%20short%20video%20streaming%20world%2C%20floating%20abstract%20play%20buttons%20and%20film%20frames%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20minimal%20geometric%20candy%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20clean%20harmonious%20composition&width=900&height=1200&seq=td-hero-cover-main&orientation=portrait"
                alt="糖豆视频 热门短视频与福利视频精选合集封面"
                title="糖豆视频精选合集"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="absolute -left-3 top-8 hidden rounded-2xl border border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur md:block">
              <p className="font-label text-[11px] text-foreground-400">今日更新</p>
              <p className="font-heading text-lg font-bold text-foreground-950">
                300<span className="text-primary-600">+</span> 条
              </p>
            </div>

            <div className="absolute -bottom-4 -right-2 hidden rounded-2xl border border-secondary-200 bg-secondary-50/95 px-4 py-3 backdrop-blur md:block">
              <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  <i className="ri-shield-check-line text-sm"></i>
                </span>
                <div>
                  <p className="font-label text-[11px] text-secondary-900/70">持续更新</p>
                  <p className="font-label text-sm font-semibold text-secondary-900">免费畅看无压力</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mx-auto flex w-full max-w-[1240px] flex-wrap items-center gap-x-10 gap-y-4 border-t border-background-200/70 px-4 py-6 md:px-8">
        {heroStats.map((stat) => (
          <div key={stat.label} className="flex items-baseline gap-2">
            <span className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {stat.value}
            </span>
            <span className="font-label text-xs text-foreground-500">{stat.label}</span>
          </div>
        ))}
        <span className="ml-auto hidden items-center gap-2 font-label text-xs text-foreground-500 sm:flex">
          <i className="ri-time-line text-base"></i>
          每日多时段更新 · 新片优先入列
        </span>
      </div>
    </section>
  );
}